import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
//import Slider from '@material-ui/core/Slider';
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import Question from './quiz/question'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const swal = withReactContent(Swal)


const singlequestionstyle = {
  margin:'5px'
}

const parameterbox = {
  display: 'flex',
  flexDirection : 'row',
  marginTop : '5px',
  padding: '5px'
}

export default class LectureQuizEdit extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      version: false,
      hints : '',
      mustreach : 0.5,
      questions : [],
      tries : 3,
      qcount : 0,

    }
  }

  componentDidMount () {
    this.setState({mustreach:this.props.pass_at || 0.5})
  }

addQuestion = () => {
  let qtmp = this.props.questions || []
  qtmp.push({text: false,  active : true,answers :[]})
  this.props.modQuiz({...this.props,questions : qtmp})
  // this.props.onTestChange(this.state)
}

removeQuestion = (i) => {
  swal.fire({
    text : 'Frage unwiederbringlich löschen?',
    confirmButtonText: 'Ja',
    showCancelButton: true,
    type : 'warning',
  }).then((data) => {
    if ('value' in data && data.value == true){
        let qtmp = this.props.questions
        qtmp.splice(i,1)
        this.props.modQuiz({...this.props,questions:qtmp})
  }})
}





modQuestion = (newval,i) => {
  let questions = this.props.questions
  questions[i] =newval
  this.props.modQuiz({...this.props,questions : questions})
}

modSlider = (newval) => {
  this.props.modQuiz({...this.props,pass_at:newval})
}

  render () {

    return (
      <div>
        <div style={parameterbox}>
      <TextField
         label="Version"
         style = {{width:'25%'}}
         value = {this.props.version || 0}
         type='number' size="small" variant="outlined"
         onChange = {e => this.props.modQuiz({...this.props,version:e.target.value})}
       />
      <TextField
         label="Fragen&nbsp;pro&nbsp;Test"
         size="small" variant="outlined"
         value = {this.props.max_questions || 0}
         type='number' style = {{width:'25%'}} 
         onChange = {e => this.props.modQuiz({...this.props,max_questions:e.target.value})}
       />
       <TextField
         label="Bestehensgrenze"
         value = {this.props.pass_at || 0}
         type='number' size="small" variant="outlined" style = {{width:'25%'}}
         inputProps={{min:0,max:1,step:0.1}}
         onChange = {e => this.props.modQuiz({...this.props,pass_at:e.target.value})}
       />
       <TextField
         label="Max.&nbsp;Versuche"
         value = {this.props.tries || 0}
         type='number' size="small" variant="outlined" style = {{width:'25%'}}
         inputProps={{min:0,max:10,step:1}}
         onChange = {e => this.props.modQuiz({...this.props,tries:e.target.value})}
       />
       </div>

      <Divider/>
        {this.props.questions && this.props.questions.map((q,i) =>
          <Paper   key={i} style={singlequestionstyle}>
            <Question {...q} index={i} modQuestion={newval => this.modQuestion(newval,i)} removeQuestion={j => this.removeQuestion(i)}/>
          </Paper>
         )}
         <Button onClick={this.addQuestion}>
         <AddCircleIcon />Frage hinzufügen
         </Button>
      </div>
    )
  }


}
